import React from "react";
import { Button, Icon, Modal, Table } from "semantic-ui-react";
import { translate } from "react-i18next";

function DetailsModal(props) {
  const [open, setOpen] = React.useState(false);

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
        <Button
          onClick={() => setOpen(true)}
          basic
          size="mini"
          type="button"
          icon
        >
          <Icon name="eye" color="blue" />
        </Button>
      }
    >
      <Modal.Header>{props.t("title") || "Vendor Share"}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  {props.t("vendor_name") || "Vendor Name"}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {props.t("share") || "Share"}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {props.data.vendors.map((ven, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{ven.vendor_name}</Table.Cell>
                  <Table.Cell>{ven.vendor_share}&nbsp;&nbsp;%</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          content={props.t("close") || "Close"}
          labelPosition="right"
          icon="close"
          onClick={() => setOpen(false)}
          info
        />
      </Modal.Actions>
    </Modal>
  );
}

export default translate("vendor_share")(DetailsModal);
